import { Notification, PlacementType } from '@amzn/aces-communications-api';
import { BANNER_LEVEL, BANNER_TYPE } from '../../../../app/slice';
import * as KatalMetrics from '@amzn/katal-metrics';
import {
  ConsoleLevelBannerMetricsPublisher,
  PageLevelBannerMetricsPublisher,
} from '../../../../commons/utils/metrics';
import { LocalNotification } from '@amzn/aac-chrome-internal-api';
export { LocalNotification } from '@amzn/aac-chrome-internal-api';

export interface PartitionedBanners {
  error: LocalNotification[];
  warning: LocalNotification[];
  info: LocalNotification[];
  total: number;
}

export interface UseAcesBannersResponseActions {
  refresh: () => void;
  display: (toMark?: Notification[]) => Promise<void>;
  read: (toMark: Notification) => Promise<void>;
  readSubNotification: (toMark: string) => Promise<void>;
  dismiss: (toMark: LocalNotification) => Promise<void>;
}
export interface UseAcesBannersResponse {
  notifications: LocalNotification[];
  actions: UseAcesBannersResponseActions;
  loading?: boolean;
}

export interface UseStardustBannersResponse {
  notifications: LocalNotification[];
}

/**
 * The Single Global Ad Account the account switcher resolved, and the member
 * entity it was resolved for. findCurrentAccountAndSiblings keys the tree walk
 * on that entity and returns its parent as the SGA, so the SGA is authoritative
 * for that entity alone.
 */
export interface SwitcherGlobalAccount {
  globalAccountId?: string;
  memberEntityId?: string;
}

export interface StardustCloudfrontResponse {
  id: string;
  description: string;
  title?: string;
  timestamp: string;
  status: 'error';
  validUntil: string;
}

export const bannerIconMap: Record<BANNER_TYPE, string> = {
  error: 'exclamation',
  warning: 'exclamation-triangle',
  info: 'info-circle',
  success: '',
};

export const bannerLocalStorageKey: Record<BANNER_LEVEL, string> = {
  console: 'dismissedBanners',
  page: 'dismissedAcesBanners',
};

export const bannerPlacementType: Record<BANNER_LEVEL, PlacementType> = {
  console: PlacementType.GLOBAL_BANNER,
  page: PlacementType.PAGE_BANNER,
};

export const bannerMetricsPublisher: Record<
  BANNER_LEVEL,
  KatalMetrics.Publisher
> = {
  console: ConsoleLevelBannerMetricsPublisher,
  page: PageLevelBannerMetricsPublisher,
};
